import { ReactElement } from "react";
import { BlockTitle } from "@blocks/Blocks";
import VerticalLatest from "@components/ArticleCard/VerticalLatest";
import Column from "@components/Grid/Column";
import Row from "@components/Grid/Row";
import SeeMore from "@components/SeeMore/SeeMore";
import ListingPageNewsletter from "@features/newsletter/ListingPageNewsletter";
import { useWindowSize } from "@hooks/useWindowSize";
import type { ArticleDataObject } from "@typings/Cue";
import { LatestStoriesRowProps } from "@typings/Verticals";
import { getKickerFromArticleDataObject } from "@util/helpers";
import cx from "classnames";

import MostReadStories from "./MostReadStories";

export default function LatestStoriesRow({
  testId,
  seeMoreLink,
  verticalName,
  articles,
  mostReadStories,
}: LatestStoriesRowProps): ReactElement {
  const { isScreenLG } = useWindowSize();

  return (
    <>
      {articles.length > 0 || mostReadStories.length > 0 ? (
        <Row rootClassName="mb-12" data-testid={testId}>
          <Column rootClassName={cx("w-full", "lg:w-8/12")}>
            {!isScreenLG ? <ListingPageNewsletter className="mb-12" /> : null}

            <BlockTitle
              text="LATEST"
              rootClassName="vertical-block-title mb-5 !font-poppins font-semibold !text-lg"
            />

            <>
              {articles?.map((article: ArticleDataObject, index: number) => {
                return (
                  <VerticalLatest
                    articleData={article}
                    rootClassName="mb-4 pb-4 border-b border-gray-250"
                    key={index}
                    verticalName={verticalName}
                    kicker={
                      article?.kicker?.fields?.[0]?.value ||
                      getKickerFromArticleDataObject(article)
                    }
                  />
                );
              })}
            </>

            <SeeMore verticalName={verticalName} link={seeMoreLink} />
          </Column>

          <Column rootClassName={cx("w-full", "lg:w-4/12")}>
            {isScreenLG && ["sme", "asean"].includes(verticalName) ? (
              <>
                <BlockTitle
                  text="NEWSLETTER"
                  rootClassName="vertical-block-title mb-5 !font-poppins font-semibold !text-lg"
                />

                <ListingPageNewsletter className="mx-auto mb-6" />
              </>
            ) : null}

            <MostReadStories
              articles={mostReadStories}
              verticalName={verticalName}
            />
          </Column>
        </Row>
      ) : null}
    </>
  );
}
